import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class IdleManagerService {

  private loggedIn = new Subject<boolean>();

  constructor() {
    this.loggedIn.next(false);
  }

  setLoggedIn(isLoggedIn: boolean) {
    this.loggedIn.next(isLoggedIn);
  }

  getLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

}
